var RecordFurtherEducationNode = /** @class */ (function () {
    function RecordFurtherEducationNode(obj) {
        this.id = obj && obj.id || "";
        this.groupId = obj && obj.groupId || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.scopeUnit = obj && obj.scopeUnit || 0;
        this.scope = obj && obj.scope || 0;
        this.validity = obj && obj.validity || 0;
        this.parent = obj && obj.parent || null;
    }
    RecordFurtherEducationNode.prototype.parentIsCollapsed = function () {
        if (!this.parent)
            return false;
        return this.parent.collapsed;
    };
    return RecordFurtherEducationNode;
}());
export { RecordFurtherEducationNode };
